<template>
  <PopUp
    bottom
    title="匯入"
    :width="width"
    :clickOutsideClose="false"
    :popUpActive="isActive.popup"
    class="lv-popup-upload-excel"
    @click="$_onClose"
  >
    <slot name="customFields" :isActive="isActive.popup"/>
    <WsRow class="mb-8">
      <WsCol v-if="exampleName" cols="3" smcols="12">
        <WsButton001
          outLine
          :isloading="isLoading.import || propIsLoading"
          @click="$_onDownloadExample"
        >
          {{ $t('下載{file}範本',{file:'xlsx'}) }}
        </WsButton001>
      </WsCol>
      <WsCol cols="3" smcols="12">
        <WsButton001
          outLine
          :isloading="isLoading.import || propIsLoading"
          @click="$_handleUploadBtnClick"
        >
          {{ $t('匯入{file}檔案',{file:'xlsx'}) }}
        </WsButton001>
      </WsCol>
    </WsRow>
    <input
      ref="fileInput"
      class="lv-popup-upload-excel__input"
      type="file"
      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
      @change="$_onChange($event)"
    >
    <grid v-if="_hasData" :auto-width="true" :resizable="true" :cols="excel.headers" :rows="excel.table"></grid>
    <LlEmptyPic
      v-else
      title="目前尚無資料"
      :image="require('@/assets/image/img-empty/Blue-file-empty.png')"
    />
    <template #bottomBtn>
      <WsButton001
        outLine
        :isloading="isLoading.import || propIsLoading"
        @click="$_onClose"
      >
        {{ $t('取消') }}
      </WsButton001>
      <WsButton001
        :disable="!file"
        :isloading="isLoading.import || propIsLoading"
        @click="$_onImport"
      >
        {{ $t('確定') }}
      </WsButton001>
    </template>
  </PopUp>
</template>

<script>
import Grid from 'gridjs-vue';
import S_file from '@/service/api/v1/file';
import H_excel from '@/helpers/excel';

export default {
  components: {
    Grid
  },
  props: {
    width: {
      type: String,
      default: '90vw'
    },
    uploadUrl: {
      type: String,
    },
    exampleName: {
      type: String,
    },
    propIsLoading: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      isActive: {
        popup: false,
      },
      isLoading: {
        import: false
      },
      excel: {
        headers: [],
        table: [],
      },
      file: null,
    }
  },
  computed: {
    _hasData() {
      return this.excel.headers.length > 0;
    }
  },
  methods: {
    $_onOpen() {
      this.isActive.popup = true;
    },
    $_onClose() {
      if (this.isLoading.import || this.propIsLoading) return;
      this.isActive.popup = false;
      this.excel = {
        headers: [],
        table: [],
      };
      this.file = null;
      this.$refs.fileInput.value = '';
    },
    $_handleUploadBtnClick() {
      this.$refs.fileInput.click();
    },
    async $_onChange($event) {
      this.file = $event.target.files[0];
      const {headers, table} = await H_excel.parse(this.file);
      this.excel.headers = headers;
      this.excel.table = table;
    },
    async $_onImport() {
      if (!this.uploadUrl) {
        this.$emit('input', this.file);
        return;
      }
      this.isLoading.import = true;
      const res = await S_file.importFile(this.uploadUrl, this.file);
      this.$emit('imported', res);
      this.isLoading.import = false;
      this.$_onClose();
    },
    $_onDownloadExample() {
      const fileUrl = `${process.env.BASE_URL}${this.exampleName}.xlsx`;
      const link = document.createElement('a');
      link.href = fileUrl;
      link.download = 'example.xlsx';
      link.click();
    },
  }
}
</script>